import { invalidateTimesheetsQuery } from '../timesheets/query';
export const crewTimesheetsQueryKey = [
    'crew-timesheets',
];
export function invalidateCrewTimesheetsQuery(queryClient) {
    return queryClient.invalidateQueries({ queryKey: crewTimesheetsQueryKey });
}
const isCrewTimesheetListQuery = (query) => query.queryKey.length === crewTimesheetsQueryKey.length + 1;
export function invalidateCrewTimesheetListsQuery(queryClient) {
    return queryClient.invalidateQueries({
        queryKey: crewTimesheetsQueryKey,
        predicate: isCrewTimesheetListQuery,
    });
}
export function invalidateAllTimesheetsQueries(queryClient) {
    return Promise.all([
        invalidateCrewTimesheetsQuery(queryClient),
        invalidateTimesheetsQuery(queryClient),
    ]);
}
//# sourceMappingURL=query.js.map